import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'chat',
  name: fr.title,
  description: fr.description,
  icon: 'message',
  color: '#0F766E',
  glyph: [{ d: 'M4 5h16v11H9l-5 4z' }, { d: 'M8 9h8M8 12h5' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: [
      'app.records.read',
      'app.records.write',
      'threads.read',
      'threads.write',
      'messages.read',
      'messages.write',
      'contacts.read',
      'interactions.read',
      'interactions.write',
    ],
    defines: [],
  },
  entities: {
    uses: [
      { entity: 'threads' },
      { entity: 'messages' },
      { entity: 'contacts' },
      { entity: 'interactions', extends: { channel: ['chat'] } },
    ],
    owns: [{ table: 'receipts', scope: 'workspace', description: fr.description }],
  },
  events: { emits: emitsOf(events), subscribes: [] },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  contributes: {
    entityActions: [
      {
        entity: 'contacts',
        label: fr.contactAction,
        icon: 'message',
        intent: 'chat.open',
        route: '/?contactId=:id',
      },
    ],
  },
  missions: { actions: ['chat.seed'], conditions: ['chat.closed'], blocks: [] },
  migrations: { schema: 'app_chat', dir: 'migrations' },
});
